//removeIf(production)
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzModal from "./claroluz-modal";

const HystModal = require('../../../../../external/hystmodal/hystmodal');
//endRemoveIf(production)

class ClaroluzModalGeneric extends ClaroluzModal {
    private buttonSelector: string;

    constructor(modalId: string, buttonSelector: string) {
        const library = new HystModal({
            linkAttributeName: "data-hystmodal",

        });
        super(library, modalId);
        this.buttonSelector = buttonSelector;

        this.clickEvent();
    }

    private clickEvent() {
        document.querySelectorAll(this.buttonSelector).forEach((element) => {
            element.addEventListener('click', () => {
                this.show();

                new ClaroluzEvents(appProperties(), 'modal', this.buttonSelector, 'open');
            });
        });
    }
}

//removeIf(production)
export default ClaroluzModalGeneric;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)